import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, useForm } from "react-hook-form";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useQyCreateRequestType } from "@factory/query/request-type.query";
import { RequestTypeFormRule, RequestTypeFormSchema } from "@factory/form/form.rule";
import { requestTypeFormDefault } from "@factory/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export function useNewRequestType() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateRequestType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New RequestType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addRequestType, isLoading: isCreating } =
    useQyCreateRequestType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<RequestTypeFormSchema>({
    defaultValues: requestTypeFormDefault,
    resolver: zodResolver(RequestTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: RequestTypeFormSchema) => {
    const formData = mapCreateRequestType(form);
    addRequestType(formData);
  };
  const handleValidateError = (err: FieldErrors<RequestTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
